export default "__VITE_ASSET__D4e_GUMn__"